var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{staticClass:"feed",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',[_vm._v(" PUBLICAÇÕES")]),_c('div',{staticClass:"risquinho"}),_c('Posts',{attrs:{"postKey":_vm.postKey}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }